module.exports = ".input-full-width {\n  width: 100%; }\n"